"use strict";

/**
 * Namespace für Service.
 *
 * @namespace
 * @memberof gc.gis
 */
gc.gis.service = gc.gis.service || {};

/**
 * Namespace für Service-Features.
 *
 * @namespace
 * @memberof gc.gis.service
 */
gc.gis.service.feature = gc.gis.service.feature || {};

/**
 * Events der Aktionen des transaktionellen FeatureService.
 *
 * @enum {string}
 */
gc.gis.service.FeatureServiceTypes = {
	/**
	 * Identifikator für den FeatureTyp einfaches Feature .
	 *
	 * @var {string}
	 */
	FEATURETYPE_FEATURE:    'Feature',
	/**
	 * Identifikator für den FeatureTyp FachDB.
	 *
	 * @var {string}
	 */
	FEATURETYPE_FACHDB:     'FachDBFeature',

	/**
	 * Identifikator für das Geometrieformat GeoJSON.
	 *
	 * @var {string}
	 */
	GEOM_FORMAT_GEOJSON:    'geojson',
	/**
	 * Identifikator für das Geometrieformat WKT.
	 *
	 * @var {string}
	 */
	GEOM_FORMAT_WKT:        'wkt',
	/**
	 * Identifikator für das Geometrieformat "leer".
	 *
	 * @var {string}
	 */
	GEOM_FORMAT_NONE:       'none'
};

/**
 * Events der Aktionen des transaktionellen FeatureService.
 *
 * @enum {string}
 */
gc.gis.service.FeatureServiceEvent = {
	/**
	 * Wird ausgelöst, wenn ein Identify-Request erfolgreich war.
	 * @event gc.gis.FeatureQueryServiceEvent#identify:success
	 */
	IDENTIFY_SUCCESS:           'identify:success',
	/**
	 * Wird ausgelöst, wenn ein Identify-Request nicht erfolgreich war.
	 * @event gc.gis.FeatureQueryServiceEvent#identify:error
	 */
	IDENTIFY_ERROR:             'identify:error',
	/**
	 * Wird ausgelöst, wenn ein Identify-Detail-Request erfolgreich war.
	 * @event gc.gis.FeatureQueryServiceEvent#identify_detail:success
	 */
	IDENTIFY_DETAIL_SUCCESS:    'identify_detail:success',
	/**
	 * Wird ausgelöst, wenn ein Identify-Detail-Request nicht erfolgreich war.
	 * @event gc.gis.FeatureQueryServiceEvent#identify_detail:error
	 */
	IDENTIFY_DETAIL_ERROR:      'identify_detail:error',
	/**
	 * Wird ausgelöst, wenn ein QueryMapFeature-Request erfolgreich war.
	 * @event gc.gis.FeatureQueryServiceEvent#query_map_features:success
	 */
	QUERY_MAP_FEATURES_SUCCESS: 'query_map_features:success',
	/**
	 * Wird ausgelöst, wenn ein QueryMapFeature-Request nicht erfolgreich war.
	 * @event gc.gis.FeatureQueryServiceEvent#iquery_map_features:error
	 */
	QUERY_MAP_FEATURES_ERROR:   'query_map_features:error',
	/**
	 * Wird ausgelöst, wenn ein HtmlPopup-Request gestartet wird.
	 * @event gc.gis.FeatureQueryServiceEvent#html_pop:start
	 */
	HTML_POPUP_START:           'html_pop:start',
	/**
	 * Wird ausgelöst, wenn ein HtmlPopup-Request erfolgreich wird.
	 * @event gc.gis.FeatureQueryServiceEvent#html_pop:success
	 */
	HTML_POPUP_SUCCESS:         'html_pop:success',
	/**
	 * Wird ausgelöst, wenn ein HtmlPopup-Request nicht erfolgreich wird.
	 * @event gc.gis.FeatureQueryServiceEvent#html_pop:error
	 */
	HTML_POPUP_ERROR:           'html_pop:error',
	/**
	 * Wird ausgelöst, wenn der Speicher-Request erfolgreich war.
	 * @event gc.gis.service.FeatureServiceEvent#add:success
	 */
	ADD_SUCCESS:                'add:success',
	/**
	 * Wird ausgelöst, wenn dar Speicher-Request nicht erfolgreich war.
	 * @event gc.gis.service.FeatureServiceEvent#add:error
	 */
	ADD_ERROR:                  'add:error',
	/**
	 * Wird ausgelöst, wenn ein Update-Request erfolgreich war.
	 * @event gc.gis.service.FeatureServiceEvent#update:success
	 */
	UPDATE_SUCCESS:             'update:success',
	/**
	 * Wird ausgelöst, wenn ein Update-Request nicht erfolgreich war.
	 * @event gc.gis.service.FeatureServiceEvent#update:error
	 */
	UPDATE_ERROR:               'update:error',
	/**
	 * Wird ausgelöst, wenn ein Lösch-Request erfolgreich war.
	 * @event gc.gis.service.FeatureServiceEvent#delete:success
	 */
	DELETE_SUCCESS:             'delete:success',
	/**
	 * Wird ausgelöst, wenn ein Lösch-Request nicht erfolgreich war.
	 * @event gc.gis.service.FeatureServiceEvent#delete:error
	 */
	DELETE_ERROR:               'delete:error'
};

/**
 * @classdesc
 * Abstrakte Wrapperklasse für FeatureServices.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCObservable
 * @memberof gc.gis.service
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {gc.gis.util.GCRequestManager} requestManager Objekt zur Ausführung von Requests
 */
gc.gis.service.AbstractFeatureService = function(requestManager)
{
	gc.gis.GCObservable.call(this);

	/**
	 * @type {gc.gis.util.GCRequestManager}
	 */
	this._requestManager    = requestManager;
};
gc.gis.service.AbstractFeatureService.prototype = Object.create(gc.gis.GCObservable.prototype);
